import { fetchNewerMessages, fetchOlderMessages, processChat } from '@/app/sync/messages';

/**
 * Conversation Service — wraps infrastructure/sync/messages.
 * All viewmodels that need conversation data must go through here,
 * never import from infrastructure/ directly.
 */

export const loadInitialMessages = activeChat => processChat(activeChat);

export const loadMoreOlderMessages = (chatJid, anchorId) => fetchOlderMessages(chatJid, anchorId);

export const loadMoreNewerMessages = (chatJid, anchorId) => fetchNewerMessages(chatJid, anchorId);
